'use client';
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import classnames from 'classnames';
import { Button, useToggle, } from '../../index.js';
export const IconToggle = (_a) => {
    var { iconName = 'heart', isPressed = false, className, onClick, text, variant, hideText = true, iconSize = 'md' } = _a, other = __rest(_a, ["iconName", "isPressed", "className", "onClick", "text", "variant", "hideText", "iconSize"]);
    const [isActive, { toggle }] = useToggle(isPressed);
    const handleClick = (e) => {
        if (onClick) {
            onClick(e);
        }
        toggle();
    };
    const componentClassName = classnames('sparky-c-icon-toggle', className, {
        'sparky-c-icon-toggle--active': isActive,
    });
    const icon = isActive ? `${iconName}-fill` : `${iconName}-outline`;
    return (_jsx(Button, Object.assign({ className: componentClassName, "aria-pressed": isActive, onClick: handleClick, iconName: icon, text: text, hideText: hideText, variant: variant, iconSize: iconSize }, other)));
};
//# sourceMappingURL=IconToggle.js.map